import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { CalendarIcon } from '@client/components/shared/SvgIcons';
import Translate from '@client/components/shared/translation/Translate';

import styles from './styles.scss';

export class CalendarReminder extends PureComponent {
    static propTypes = {
        campaign: PropTypes.object.isRequired,
        onReminderClick: PropTypes.func.isRequired
    }

    render() {
        const { campaign: { campaignIdentifier } } = this.props;

        return (
            <a
                styleName="campaign-reminder"
                onClick={this.handleReminderClick}
                href={`/calendar/${campaignIdentifier}`}
            >
                <Translate message="campaigns.addToCalendar" />
                <CalendarIcon styleName="calendar-icon" />
            </a>
        );
    }

    handleReminderClick = () => {
        const { onReminderClick, campaign } = this.props;
        onReminderClick(campaign);
    }
}

export default CSSModules(CalendarReminder, styles);
